import type {
    ComponentType,
    FC
} from "react";
import type ICarouselNextProps from "./type";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import type {
    CarouselPartContentProps
} from "../../type";
import {
    ChevronRight as ChevronRightIcon,
    ChevronDown as ChevronDownIcon
} from "lucide-react-native";
import {
    withCarouselContext
} from "../../context";
import CarouselControl from "../../internal/control";

const CarouselNextContent: FC<CarouselPartContentProps<ICarouselNextProps>> = ({
    "aria-label": ariaLabel,
    borderRadius,
    customTheme,
    context,
    style
}) => {
    const {
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    return <CarouselControl
        icon={context.orientation === "vertical" ? ChevronDownIcon : ChevronRightIcon}
        isOverlaid={context.controlsPlacement === "inside"}
        customTheme={customTheme ?? context.customTheme}
        label={ariaLabel ?? localize("next-slide")}
        isDisabled={context.isNextDisabled}
        borderRadius={borderRadius}
        isSignatureEnabled={true}
        onPress={context.goNext}
        size={context.size}
        style={style}
    />;
};

const CarouselNext: ComponentType<ICarouselNextProps> = withCarouselContext("next", CarouselNextContent);
export default CarouselNext;
